import axios from "axios";
import getCookies from "./getCookie";
import { access_token } from "../api/CookieKeys";

export const getBearer = (type: string) => {
    const access_token_value = getCookies(access_token);

    // Add ngrok-skip-browser-warning header to bypass ngrok interstitial page
    const setHeaders = (axiosHeaders: any) => {
        axiosHeaders['Authorization'] = `Bearer ${access_token_value}`;
        axiosHeaders['ngrok-skip-browser-warning'] = 'true';
    };

    const types: any = {
        'get': setHeaders(axios.defaults.headers.get),
        'post': setHeaders(axios.defaults.headers.post),
        'delete': setHeaders(axios.defaults.headers.delete),
        'put': setHeaders(axios.defaults.headers.put),
        'patch': setHeaders(axios.defaults.headers.patch)
    };

    return types[type];
}